import { render, staticRenderFns } from "./inspectionPerson.vue?vue&type=template&id=3152d5f0&scoped=true&"
import script from "./inspectionPerson.vue?vue&type=script&lang=js&"
export * from "./inspectionPerson.vue?vue&type=script&lang=js&"
import style0 from "./inspectionPerson.vue?vue&type=style&index=0&id=3152d5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152d5f0",
  null
  
)

export default component.exports